import React from 'react';
import { cn } from '../utils/cn';

const BtnFilled = ({ title, btnCb, disabled = false, className, type = 'button' }) => {
  return (
    <button
      disabled={disabled}
      onClick={() => btnCb?.()}
      type={type}
      className={cn(
        `cursor-pointer w-full truncate bg-gray-900 hover:bg-orange-500 transition text-white font-semibold py-2 px-4 hover:border-orange-500 rounded-full disabled:bg-gray-300 disabled:cursor-not-allowed`,
        className
      )}>
      {title}
    </button>
  );
};

export default BtnFilled;
